"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 20 20",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M13.713 3.855a.7.7 0 0 1 .71.69l.012.842c.89.131 1.524.522 1.942 1.052.493.626.609 1.351.622 1.804a.7.7 0 1 1-1.4.04c-.008-.289-.085-.676-.322-.978-.211-.268-.626-.567-1.532-.567-.935 0-1.357.304-1.565.567-.232.295-.298.672-.29.938.007.263.068.421.133.523a.83.83 0 0 0 .33.28c.359.187.866.27 1.539.37l.052.007c.591.088 1.333.197 1.918.517.322.175.621.425.834.786.212.36.308.782.303 1.254-.013 1.135-.472 1.92-1.184 2.386-.433.283-.923.423-1.382.486l-.01.606a.7.7 0 1 1-1.4-.024l.01-.612a3.6 3.6 0 0 1-1.402-.62c-.646-.48-1.141-1.232-1.141-2.23a.7.7 0 1 1 1.4 0c0 .485.224.845.576 1.107.37.274.859.418 1.279.418.502 0 .974-.088 1.305-.303.28-.184.541-.512.55-1.23.002-.27-.052-.43-.11-.528a.73.73 0 0 0-.298-.268c-.34-.185-.834-.268-1.506-.368l-.069-.01c-.588-.087-1.324-.196-1.913-.503a2.2 2.2 0 0 1-.858-.763c-.226-.352-.342-.769-.356-1.241-.013-.476.092-1.211.59-1.844.42-.532 1.059-.92 1.955-1.051l-.012-.823a.7.7 0 0 1 .69-.71M3 6.962A1.7 1.7 0 0 1 4.7 5.26h1.52c1.722 0 3.295 1.23 3.295 2.948 0 1.284-.876 2.294-2.037 2.724l1.925 2.965a.7.7 0 0 1-1.175.762l-2.273-3.502h-1.55v3.235a.7.7 0 0 1-1.4 0v-3.935zm1.404 2.795H6.22c1.144 0 1.895-.784 1.895-1.549S7.366 6.66 6.221 6.66h-1.52a.3.3 0 0 0-.3.3z",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=CurrencyBrazilRealIcon20.js.map